/**
 * Date-extensions locale Galician [gl]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('gl', {
    monthNames: ['Xaneiro','Febreiro','Marzo','Abril','Maio','Xuño','Xullo','Agosto','Setembro','Outubro','Novembro','Decembro'],
    monthShortNames: ['Xan.','Feb.','Mar.','Abr.','Mai.','Xuñ.','Xul.','Ago.','Set.','Out.','Nov.','Dec.'],
    dayNames: ['Domingo','Luns','Martes','Mércores','Xoves','Venres','Sábado'],
    dayShortNames: ['Dom.','Lun.','Mar.','Mér.','Xov.','Ven.','Sáb.']
});
